import { Virtuoso } from 'react-virtuoso';

import { Spinner } from '../spinner';

import type { JSX } from 'react';
import type { VirtuosoProps } from 'react-virtuoso';

import s from './VirtualList.module.css';

const getFooterComponent = ({ isLoading }: { isLoading?: boolean }) => {
  let Component: JSX.Element | null = null;

  if (isLoading) {
    Component = <Spinner className={s.spinner} />;
  }

  return () => Component ?? null;
};

type VirtualListProps<T, C> = Omit<VirtuosoProps<T, C>, 'data' | 'totalCount'> & {
  data: T[];
  totalCount: number;
  isLoading?: boolean;
};

export const VirtualList = <T, C = unknown>({
  components,
  data,
  isLoading,
  totalCount,
  ...props
}: VirtualListProps<T, C>) => (
  <Virtuoso
    components={{
      Footer: getFooterComponent({ isLoading }),
      ...components,
    }}
    data={data}
    totalCount={totalCount}
    {...props}
  />
);
